// File: ModalSetupFinance.js
import React, { useState, useEffect } from 'react';
import dayjs from 'dayjs';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Button,
  Box,
} from '@mui/material';
import { useDispatch } from 'react-redux';
import * as actions from '../../../redux/actions'; // ตรวจสอบ Path นี้ให้ถูกต้อง
import _ from 'lodash';
import financeConstants from '../../../utils/constants/finance.constant';
const { TRANSACTION_TYPES, ACTIVITY_TYPES, PAYMENT_METHODS } = financeConstants;
// 1. รับ props: open, onClose, accounts, และ onSaveSuccess (ก็คือ fetchData)
const ModalSetupFinance = ({ open, onClose, accounts, onSaveSuccess }) => {
  const dispatch = useDispatch();
  const [date, setDate] = useState(dayjs().format('YYYY-MM-DD'));
  const [amounts, setAmounts] = useState({});
  const [saving, setSaving] = useState(false);
  // 3. เมื่อ Modal เปิด (prop 'open' เปลี่ยน) ให้ล้างค่าเก่า
  useEffect(() => {
    if (open) {
      setAmounts({});
      setDate(dayjs().format('YYYY-MM-DD'));
    }
  }, [open]);

  // 4. Handler สำหรับอัปเดตยอดเงิน
  const handleAmountChange = (bankId) => (e) => {
    const value = e.target.value;
    setAmounts((prev) => ({
      ...prev,
      [bankId]: value,
    }));
  };
  const accountBasic = _.filter(accounts, (o) => o.status === false);

  const handleSave = async () => {
    try {
      setSaving(true);

      // สร้าง array ของธนาคารที่มีการกรอกยอด
      const dataToSave = accounts
        .filter((b) => amounts[b._id] && parseFloat(amounts[b._id]) > 0)
        .map((b) => ({
          id: b._id,
          name: b.name,
          bankName: b.bankName,
          startAmount: parseFloat(amounts[b._id]),
          currentAmount: parseFloat(amounts[b._id]),
          accountNumber: b.accountNumber || '',
          status: true,
          isCash: b.isCash || false,
          transactions: [
            {
              amount: parseFloat(amounts[b._id]),
              date: dayjs(date).toDate(),
              // type: TRANSACTION_TYPES.INCOME,
              // transactionType: ACTIVITY_TYPES.INCOME,
              bankName: b.bankName,
            },
          ],
        }));

      if (dataToSave.length === 0) {
        alert('กรุณาใส่จำนวนเงินอย่างน้อยหนึ่งบัญชี');
        setSaving(false);
        return;
      }

      await Promise.all(
        dataToSave.map((bank) => dispatch(actions.bankPut(bank.id, bank))),
      );
      onSaveSuccess?.();
      onClose();
    } catch (error) {
      console.error('❌ Error saving starting balances:', error);
      alert('เกิดข้อผิดพลาดในการบันทึกข้อมูล');
    } finally {
      setSaving(false);
    }
  };

  // 8. Dialog จะใช้ props `open` และ `onClose` จากแม่
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>ตั้งค่าเงินตั้งต้น</DialogTitle>
      <DialogContent>
        <Box
          sx={{ maxHeight: '400px', overflow: 'auto', pr: 1 }}
          className="mt-2"
        >
          {accountBasic && accountBasic.length > 0 ? (
            accountBasic.map((b) => (
              <TextField
                key={b._id}
                label={`${b.name} (${b.bankName})`}
                type="number"
                fullWidth
                value={amounts[b._id] || ''}
                onChange={handleAmountChange(b._id)}
                sx={{ mb: 2 }}
              />
            ))
          ) : (
            <Box
              sx={{
                textAlign: 'center',
                py: 3,
                color: 'gray',
                fontSize: '1rem',
                fontStyle: 'italic',
              }}
            >
              ไม่มีข้อมูล
            </Box>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          ยกเลิก
        </Button>
        <Button onClick={handleSave} variant="contained" color="primary">
          บันทึก
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default ModalSetupFinance;
